import BackButton from "../../Components/BackButton";
import MyAccountDropdown from "../../Components/MyAccountDropdown";
import MyDetailsBar from "./UserOffCanvasComponents/MyDetailsBar";
import NewDetailsForm from "./UserOffCanvasComponents/NewDetailsForm";
import ProgressBar from "./UserOffCanvasComponents/ProgressBar";
import UserOffCanvasHeader from "./UserOffCanvasComponents/UserOffCanvasHeader";

export default function UserOffCanvasMenuMain({func}) {

    const styles = `offCanvasMenu__main p-4 sm:p-0 col-start-1 sm:col-start-2 col-end-13 sm:col-end-12 xl:col-end-10 row-start-1 sm:row-start-2 row-end-13 flex flex-col `

    return (
        <div className={styles}>
            <BackButton func={func} customStyles={`flex flex-row justify-start items-center text-white pr-4 sm:hidden gap-4 text-xl mb-8`}/>
            <MyAccountDropdown />
            <UserOffCanvasHeader func={func} />
            <MyDetailsBar />
            <ProgressBar />
            <NewDetailsForm />
        </div>
    );
}
